import _ from 'lodash'

// `_.set` on a reactive object adds a missing key that Vue 2 does not track:
// the value is there, but nothing that reads it re-renders. This sets each
// missing step with vm.$set instead, so a key the object never had becomes
// reactive like the rest.
export function setReactive (vm, obj, path, value) {
    const keys = _.toPath(path)
    let target = obj
    keys.slice(0, -1).forEach((key) => {
        if (!_.isObject(target[key])) {
            vm.$set(target, key, {})
        }
        target = target[key]
    })
    vm.$set(target, _.last(keys), value)
}
